import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MetaService } from 'app/services/meta.service';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-api-overview-family',
  templateUrl: './api-overview-family.component.html',
  standalone: false,
  host: {
    '[class.-lowcode-nocode]': 'isLowcodeNocode'
  }
})
export class ApiOverviewFamilyComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy{
    docIndexReady = false;
    isDocIndex = false;
    hasContact = true;
    isLowcodeNocode = false;
    contentViewObserver: MutationObserver;
    constructor(
      public fragmentService: FragmentService,
      public metaService: MetaService
      ) {
      super(fragmentService, metaService);
     }
    ngOnInit(): void {
        this.subscription.add(
         this.metaService.metadata.pipe(distinctUntilChanged()).subscribe((pMeta) => {
           this.docIndexReady = false;
           this.hasContact = pMeta?.['contact-block'] === undefined ? true : pMeta['contact-block'];
           this.isDocIndex = pMeta?.['page-index'] === undefined ? true : pMeta['page-index'];
           this.isLowcodeNocode = pMeta?.['type'] === 'lowcode-nocode';
         })
       );
    }

    ngAfterViewInit(): void {
      const contentViewerElement = document.querySelector('content-viewer');
      if (contentViewerElement) {
         if (contentViewerElement.childNodes.length > 0) {
           this.docIndexReady = true;
           return;
         }
         this.contentViewObserver = new MutationObserver((mutations) => {
           const hasRenderedContent = contentViewerElement.childNodes.length > 0;
           const hasRelevantMutation = mutations.some((mutation) =>
             mutation.type === 'childList' ||
             mutation.type === 'attributes'
           );
           if (hasRenderedContent || hasRelevantMutation) {
             this.docIndexReady = true;
             this.contentViewObserver.disconnect();
           }
         });
         this.contentViewObserver.observe(contentViewerElement, {
           attributes: true,
           childList: true,
           subtree: true
         });
      }
    }

    ngOnDestroy(): void {
      if (this.contentViewObserver) {
        this.contentViewObserver.disconnect();
      }
      super.ngOnDestroy();
    }
}
